import React, { useState } from 'react';
import './Common.css';
import NetworkSwitcher from '../Header/NetworkSwitcher';
import WalletConnect from '../Header/WalletConnect';

const Header = ({ title = "AVO Protocol Explorer", subtitle = "Blockchain Explorer" }) => {
  const [currentNetwork, setCurrentNetwork] = useState('devnet'); // Default to devnet (localhost)
  const [networkConfig, setNetworkConfig] = useState({
    id: 'devnet',
    name: 'AVO Devnet',
    rpcUrl: 'http://localhost:9545',
    chainId: 9998,
    explorer: 'http://localhost:3000',
    color: '#ff4444',
    icon: '🔴'
  });

  const handleNetworkChange = (network) => {
    setCurrentNetwork(network.id);
    setNetworkConfig(network);
    console.log('Network changed to:', network.name);
    
    // Refresh page data with new network
    window.dispatchEvent(new CustomEvent('networkChanged', { detail: network }));
  };

  const handleWalletConnected = (address) => {
    console.log('Wallet connected:', address);
  };

  const handleWalletDisconnected = () => {
    console.log('Wallet disconnected');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-branding">
          <h1 className="header-title">{title}</h1>
          <p className="header-subtitle">{subtitle}</p>
        </div>
        
        <div className="header-actions">
          <NetworkSwitcher 
            currentNetwork={currentNetwork}
            onNetworkChange={handleNetworkChange}
          />
          
          <WalletConnect 
            network={networkConfig}
            onWalletConnected={handleWalletConnected}
            onWalletDisconnected={handleWalletDisconnected}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;